import { useFilterStore, FilterStateModel } from "./store";

export const useFilterState = (): FilterStateModel => useFilterStore();
